import client from './client'
import { ClientUpdateNotification } from '../types/models/ClientUpdateNotification'

export const getClientUpdateNotifications = async (): Promise<
  ClientUpdateNotification[]
> => {
  const response = await client.get('/api/client-update-notifications/')
  return response.data
}
